import { useMemo } from 'react';
import { useSelector } from 'react-redux';
import { featureToggleSelectors } from '@makemydeal/dr-shared-store';
import * as firstPencilSelectors from '@makemydeal/dr-dash-store/selectors/firstPencilSelectors';

import { buildProgramIncentiveRows } from './utils';
import type { FirstPencilIncentiveRow, FirstPencilProgramRow, FirstPencilProgramsOfferType } from './types';

export const useFirstPencilIncentiveRows = (
    program: FirstPencilProgramRow | undefined,
    offerType: FirstPencilProgramsOfferType
): FirstPencilIncentiveRow[] => {
    const isRestorationEnabled = useSelector(featureToggleSelectors.isProgramIncentivesRestorationEnabled);
    const incentives = useSelector(firstPencilSelectors.getProgramsIncentives);
    const selectedIncentives = useSelector(firstPencilSelectors.getSelectedIncentives);

    return useMemo(
        () => buildProgramIncentiveRows(program, incentives, offerType, isRestorationEnabled, selectedIncentives),
        [program, incentives, offerType, isRestorationEnabled, selectedIncentives]
    );
};

export const useSelectedProgramIncentiveRows = (offerType: FirstPencilProgramsOfferType): FirstPencilIncentiveRow[] => {
    const selectedProgram = useSelector(firstPencilSelectors.getSelectedProgram);
    const program = selectedProgram?.offerType === offerType ? (selectedProgram.program as FirstPencilProgramRow) : undefined;
    return useFirstPencilIncentiveRows(program, offerType);
};
